<template>
  <div class="container-fluid">
    <div class="row" v-if="false">
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="853"></animated-number>
                    </h3>
                    <h6 class="stats-title">Messages</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="now-ui-icons business_money-coins"></i>
                    </div>
                    <h3 class="info-title">
                      <small>$</small>
                      <animated-number :value="3521"></animated-number>
                    </h3>
                    <h6 class="stats-title">Today Revenue</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-info">
                      <i class="now-ui-icons users_single-02"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="562"></animated-number>
                    </h3>
                    <h6 class="stats-title">Customers</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-danger">
                      <i class="now-ui-icons objects_support-17"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="353"></animated-number>
                    </h3>
                    <h6 class="stats-title">Support Requests</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card card-default card-raised">
            <div class="card-header">
              <div class="row">
                <div class="col-8">
                  <h4 class="card-title" v-if="programmes.length > 0">Programmes</h4>
                  <p class="card-text" v-if="programmes.length > 0">Below is a list of programmes available for you. These are programmes or events that you can register or view. </p>
                  <p class="card-text" v-else>Sorry, There are no programmes available for you to register now.</p>
                </div>
                <div class="col-4" v-if="isAdmin">
                  <el-select class="select-primary" placeholder="Select Batch" v-model="currentBatch" filterable>
                      <el-option v-for="(batch, index) in batches" class="select-primary" :value="batch" :label="`${batch}`" :key="index">
                      </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="card-body"></div>
        </div>
      </div>
    </div>

    <div class="row justify-content-start">
      <div class="col-md-4 col-sm-6 col-xs-12" v-for="(programme, index) in programmes" :key="index">
        <PreviewCard v-bind="programme" entity="programme" v-on:card-click="onCardClick"></PreviewCard>
      </div>
    </div>
    
  </div>
</template>
<script>
import { Select, Option } from 'element-ui';
import { PreviewForm, PreviewCard, StatsCard, Card, AnimatedNumber } from 'src/components'
import { mapGetters } from 'vuex'

export default {
  components: {
    StatsCard,
    Card,
    AnimatedNumber,
    PreviewForm,
    PreviewCard,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mounted(){
    this.$store.commit('setProgrammes', [])
    if(this.isAdmin){
      this.$store.dispatch('getBatches')
    }
    else{
      this.$store.dispatch('getUserProgrammes')
    }
  },
  data() {
    return {
      currentBatch: null
    }
  },
  computed: {
        ...mapGetters({
            batches: 'getBatches',
            programmes: 'getProgrammes',
            preferences: 'getPreferences',
            registrations: 'getRegistrations'
        }),
        isAdmin(){
          return this.$currentUser.roles.includes('admin')
        }
  },
  watch:{
    currentBatch(val){
      this.$store.dispatch('getUserProgrammesByBatch', val)
    }
  },
  methods: {
    onCardClick(link){
      console.log(this.isAdmin, this.currentBatch);
      if(this.isAdmin && this.currentBatch){
        // if admin is trying to check as a student from a particular batch
        this.$router.push(`/programmes/view/${link}/${this.currentBatch}`)
      }
      else{
        this.$router.push(`/programmes/view/${link}`)
      }
    }
  }
}
</script>
<style>
</style>
